export const TableCellType = {
	String: "string",
	Number: "number",
	Checkbox: "checkbox",
	Badge: "badge",
	Editable: "editable",
};
